const menuAbout = [
  { id: 1, status: true, link: "/pages/about", name: "ประวัติความเป็นมา" },
  { id: 2, status: true, link: "/pages/about2", name: "พันธกิจและวิสัยทัศน์" },
  { id: 3, status: true, link: "/pages/about3", name: "ผู้บริหาร" },
  { id: 4, status: true, link: "/pages/about4", name: "โครงสร้างศูนย์" },
];

const specialClinic = [
  {
    id: 1,
    status: true,
    img: "/images/animal/01.png",
    link: "/clinic/page",
    name: "คลินิกโรคผิวหนัง",
    vet: [
      {
        personID: 1,
        img: "/images/pic_img_vet_clinic/clinic_1/1.png",
        prefix: "ผศ.ดร.สพ.ญ.",
        frist_name: "กรรณิการ์",
        last_name: "พงษ์รูป",
        skill: "",
        floot: "ชั้น 2",
        room: "A2045",
        Checkin: {
          date: [
            { timeId: 1, time: "08:30 - 16.30", day: "พฤหัสบดี", status: true },
          ],
        },
      },
      {
        personID: 2,
        img: "/images/pic_img_vet_clinic/clinic_1/2.png",
        prefix: "สพ.ญ.",
        frist_name: "ณัฐวัณณ์",
        last_name: "ศรีฟ้าวัฒนา",
        skill: "",
        floot: "ชั้น 2",
        room: "A2045",
        Checkin: {
          date: [
            { timeId: 1, time: "08:30 - 16.30", day: "อังคาร", status: true },
          ],
        },
      },
    ],
  },
  {
    id: 2,
    status: true,
    img: "/images/animal/02.png",
    link: "",
    name: "คลินิกโรคตา",
    vet: [
      {
        personID: 1,
        img: "/images/pic_img_vet_clinic/clinic_2/1.png",
        prefix: "อ.ดร.สพ.ญ.",
        frist_name: "ชมพูนุท",
        last_name: "เพิ่มคำ",
        skill: "",
        floot: "ชั้น 2",
        room: "A2057",
        Checkin: {
          date: [
            { timeId: 1, time: "08:30 - 16.30", day: "จันทร์", status: true },
            { timeId: 2, time: "08:30 - 16.30", day: "อังคาร", status: true },
          ],
        },
      },
    ],
  },
  {
    id: 3,
    status: true,
    img: "/images/animal/03.png",
    link: "",
    name: "คลินิกช่องปากและทันตกรรม",
    vet: [
      {
        personID: 1,
        img: "/images/pic_img_vet_clinic/clinic_3/1.png",
        prefix: "ผศ.ดร.น.สพ.",
        frist_name: "เกรียงไกร",
        last_name: "ทองก้อน",
        skill: "",
        floot: "ชั้น 1",
        room: "A1068",
        Checkin: {
          date: [
            { timeId: 1, time: "08:30 - 16.30", day: "พฤหัสบดี", status: true },
          ],
        },
      },
    ],
  },
  {
    id: 4,
    status: true,
    img: "/images/animal/04.png",
    link: "",
    name: "คลินิกกระดูกและข้อต่อ",
    vet: [
      {
        personID: 1,
        img: "/images/pic_img_vet_clinic/clinic_4/1.png",
        prefix: "รศ.ดร.สพ.ญ.",
        frist_name: "อารีรัตน์",
        last_name: "อากาศวิภาต",
        skill: "",
        floot: "ชั้น 2",
        room: "A2056",
        Checkin: {
          date: [
            { timeId: 1, time: "08:30 - 16.30", day: "พุธ", status: true },
          ],
        },
      },
      {
        personID: 2,
        img: "/images/pic_img_vet_clinic/clinic_4/2.png",
        prefix: "อ.ดร.น.สพ.",
        frist_name: "สนธยา",
        last_name: "อ่ำสำอางค์",
        skill: "",
        floot: "ชั้น 2",
        room: "A2056",
        Checkin: {
          date: [
            { timeId: 1, time: "08:30 - 16.30", day: "จันทร์", status: true },
          ],
        },
      },
    ],
  },
  {
    id: 5,
    status: true,
    img: "/images/animal/05.png",
    link: "",
    name: "คลินิกหัวใจและหลอดเลือด",
    vet: [
      {
        personID: 1,
        img: "/images/pic_img_vet_clinic/clinic_5/1.png",
        prefix: "รศ.ดร.น.สพ.",
        frist_name: "ชวลิต",
        last_name: "บุญญาภากร",
        skill: "",
        floot: "ชั้น 2",
        room: "A2051",
        Checkin: {
          date: [
            { timeId: 1, time: "08:30 - 16.30", day: "อังคาร", status: true },
            { timeId: 2, time: "08:30 - 16.30", day: "พฤหัสบดี", status: true },
            { timeId: 3, time: "08:30 - 12.00", day: "ศุกร์", status: true },
          ],
        },
      },
      {
        personID: 2,
        img: "/images/pic_img_vet_clinic/clinic_5/2.png",
        prefix: "ผศ.ดร.น.สพ.",
        frist_name: "วันพิทักษ์",
        last_name: "ป้องกัน",
        skill: "",
        floot: "ชั้น 2",
        room: "A2051",
        Checkin: {
          date: [
            { timeId: 1, time: "08:30 - 16.30", day: "พุธ", status: true },
          ],
        },
      },
    ],
  },
  {
    id: 6,
    status: true,
    img: "/images/animal/06.png",
    link: "",
    name: "คลินิกระบบประสาทและสมอง",
    vet: [
      {
        personID: 1,
        img: "/images/pic_img_vet_clinic/clinic_6/1.png",
        prefix: "ผศ.ดร.น.สพ.",
        frist_name: "วสันต์",
        last_name: "ตั้งโภคานนท์",
        skill: "",
        floot: "ชั้น 2",
        room: "A2055",
        Checkin: {
          date: [
            { timeId: 1, time: "08:30 - 16.30", day: "พุธ", status: true },
          ],
        },
      },
      {
        personID: 2,
        img: "/images/pic_img_vet_clinic/clinic_6/2.png",
        prefix: "สพ.ญ.",
        frist_name: "ศลิษา",
        last_name: "เลิศศรีมงคล",
        skill: "",
        floot: "ชั้น 2",
        room: "A2055",
        Checkin: {
          date: [
            { timeId: 1, time: "08:30 - 16.30", day: "อังคาร", status: true },
          ],
        },
      },
    ],
  },
  {
    id: 7,
    status: true,
    img: "/images/animal/07.png",
    link: "",
    name: "คลินิกโรคแมว",
    vet: [
      {
        personID: 1,
        img: "/images/pic_img_vet_clinic/clinic_7/1.png",
        prefix: "รศ.ดร.สพ.ญ.",
        frist_name: "คคนางค์",
        last_name: "ปิยะรังษี",
        skill: "",
        floot: "ชั้น 2",
        room: "-",
        Checkin: {
          date: [
            { timeId: 1, time: "08:30 - 16.30", day: "จันทร์", status: true },
          ],
        },
      },
      {
        personID: 2,
        img: "/images/pic_img_vet_clinic/clinic_7/2.png",
        prefix: "ผศ.ดร.สพ.ญ.",
        frist_name: "ชลลดา",
        last_name: "โสดารัตน์",
        skill: "",
        floot: "ชั้น 2",
        room: "-",
        Checkin: {
          date: [
            { timeId: 1, time: "08:30 - 16.30", day: "อังคาร", status: true },
          ],
        },
      },
    ],
  },
  {
    id: 8,
    status: true,
    img: "/images/animal/08.png",
    link: "",
    name: "คลินิกโรคเนื้องอก",
    vet: [
      {
        personID: 1,
        img: "/images/pic_img_vet_clinic/clinic_8/1.png",
        prefix: "ผศ.ดร.น.สพ.",
        frist_name: "อติกันต์",
        last_name: "ทองทาบ",
        skill: "",
        floot: "ชั้น 2",
        room: "A2060",
        Checkin: {
          date: [
            { timeId: 1, time: "08:30 - 16.30", day: "พฤหัสบดี", status: true },
          ],
        },
      },
      {
        personID: 2,
        img: "/images/pic_img_vet_clinic/clinic_8/4.png",
        prefix: "อ.น.สพ.",
        frist_name: "อภินันท์",
        last_name: "โพธิ์ศรี",
        skill: "",
        floot: "ชั้น 2",
        room: "A2060",
        Checkin: {
          date: [
            { timeId: 1, time: "08:30 - 16.30", day: "พฤหัสบดี", status: true },
          ],
        },
      },
      {
        personID: 3,
        img: "/images/pic_img_vet_clinic/clinic_8/2.png",
        prefix: "น.สพ.",
        frist_name: "ณัฐชนน",
        last_name: "พิชัยยา",
        skill: "",
        floot: "ชั้น 2",
        room: "A2060",
        Checkin: {
          date: [
            { timeId: 1, time: "08:30 - 16.30", day: "อังคาร", status: true },
            { timeId: 2, time: "08:30 - 16.30", day: "พฤหัสบดี", status: true },
          ],
        },
      },
      {
        personID: 4,
        img: "/images/pic_img_vet_clinic/clinic_8/3.png",
        prefix: "สพ.ญ.",
        frist_name: "วรัญญา",
        last_name: "สิงห์เผือก",
        skill: "",
        floot: "ชั้น 2",
        room: "A2060",
        Checkin: {
          date: [
            { timeId: 1, time: "08:30 - 16.30", day: "พฤหัสบดี", status: true },
          ],
        },
      },
    ],
  },
  {
    id: 9,
    status: true,
    img: "/images/animal/09.png",
    link: "",
    name: "คลินิกกายภาพบำบัด",
    vet: [
      {
        personID: 1,
        img: "/images/pic_img_vet_clinic/clinic_9/2.png",
        prefix: "สพ.ญ.",
        frist_name: "ศลิษา",
        last_name: "เลิศศรีมงคล",
        skill: "",
        floot: "ชั้น 1",
        room: "-",
        Checkin: {
          date: [
            { timeId: 1, time: "08:30 - 16.30", day: "อังคาร", status: true },
          ],
        },
      },
    ],
  },
  {
    id: 10,
    status: true,
    img: "/images/animal/10.png",
    link: "",
    name: "คลินิกฮอร์โมนและต่อมไร้ท่อ",
    vet: [
      {
        personID: 1,
        img: "/images/pic_img_vet_clinic/clinic_10/1.png",
        prefix: "รศ.ดร.สพ.ญ.",
        frist_name: "จารุวรรณ",
        last_name: "คนมี",
        skill: "",
        floot: "ชั้น 2",
        room: "A2047",
        Checkin: {
          date: [
            { timeId: 1, time: "08:30 - 16.30", day: "อังคาร", status: true },
          ],
        },
      },
    ],
  },
  {
    id: 11,
    status: true,
    img: "/images/animal/11.png",
    link: "",
    name: "คลินิกระบบทางเดินอาหาร",
    vet: [
      {
        personID: 1,
        img: "/images/pic_img_vet_clinic/clinic_11/1.png",
        prefix: "รศ.ดร.น.สพ.",
        frist_name: "วรพัฒน์",
        last_name: "ประชาศิลป์ชัย",
        skill: "",
        floot: "ชั้น 2",
        room: "-",
        Checkin: {
          date: [
            { timeId: 1, time: "08:30 - 16.30", day: "พฤหัสบดี", status: true },
          ],
        },
      },
      {
        personID: 2,
        img: "/images/pic_img_vet_clinic/clinic_11/2.png",
        prefix: "ผศ.ดร.สพ.ญ.",
        frist_name: "ปิ่นกาญจน์",
        last_name: "จันทวงค์",
        skill: "",
        floot: "ชั้น 2",
        room: "-",
        Checkin: {
          date: [
            { timeId: 1, time: "13:00 - 16.30", day: "พฤหัสบดี", status: true },
          ],
        },
      },
    ],
  },
  {
    id: 12,
    status: true,
    img: "/images/animal/12.png",
    link: "",
    name: "คลินิกโรคไต",
    vet: [
      {
        personID: 1,
        img: "/images/pic_img_vet_clinic/clinic_12/1.png",
        prefix: "ผศ.ดร.น.สพ.",
        frist_name: "สหัสชัย",
        last_name: "ตั้งตรงทรัพย์",
        skill: "",
        floot: "ชั้น 2",
        room: "A2052",
        Checkin: {
          date: [
            { timeId: 1, time: "08:30 - 16.30", day: "จันทร์", status: true },
          ],
        },
      },
      {
        personID: 2,
        img: "/images/pic_img_vet_clinic/clinic_12/2.png",
        prefix: "สพ.ญ.",
        frist_name: "พัทธรา",
        last_name: "สอาดอาวุธ",
        skill: "",
        floot: "ชั้น 2",
        room: "A2052",
        Checkin: {
          date: [
            { timeId: 1, time: "08:30 - 16.30", day: "อังคาร", status: true },
          ],
        },
      },
    ],
  },
  {
    id: 13,
    status: true,
    img: "/images/animal/13.png",
    link: "",
    name: "คลินิกฝั่งเข็ม",
    vet: [
      {
        personID: 1,
        img: "/images/pic_img_vet_clinic/clinic_13/1.png",
        prefix: "ผศ.ดร.สพ.ญ.",
        frist_name: "ปรกต",
        last_name: "รุ่งศรี",
        skill: "",
        floot: "ชั้น 2",
        room: "A2053",
        Checkin: {
          date: [
            { timeId: 1, time: "08:30 - 16.30", day: "จันทร์", status: true },
          ],
        },
      },
      {
        personID: 2,
        img: "/images/pic_img_vet_clinic/clinic_13/2.png",
        prefix: "น.สพ.",
        frist_name: "จตุภัทร",
        last_name: "อัมพรพฤติ",
        skill: "",
        floot: "ชั้น 2",
        room: "A2053",
        Checkin: {
          date: [
            { timeId: 1, time: "08:30 - 16.30", day: "จันทร์", status: true },
            { timeId: 2, time: "08:30 - 16.30", day: "พุธ", status: true },
            { timeId: 3, time: "08:30 - 16.30", day: "ศุกร์", status: true },
          ],
        },
      },
    ],
  },
  {
    id: 14,
    status: true,
    img: "/images/animal/14.png",
    link: "",
    name: "คลินิกสัตว์เลี้ยงชนิดพิเศษ",
    vet: [
      {
        personID: 1,
        img: "/images/pic_img_vet_clinic/clinic_14/1.png",
        prefix: "สพ.ญ.",
        frist_name: "ณิชารีย์",
        last_name: "ลือวิฑูรเวชกิจ",
        skill: "",
        floot: "ชั้น 2",
        room: "A2041, A2062, A2063",
        Checkin: {
          date: [
            { timeId: 1, time: "08:30 - 16.30", day: "อังคาร", status: true },
            { timeId: 1, time: "08:30 - 16.30", day: "พุธ", status: true },
            { timeId: 1, time: "08:30 - 16.30", day: "พฤหัสบดี", status: true },
            { timeId: 1, time: "08:30 - 16.30", day: "ศุกร์", status: true },
          ],
        },
      },
    ],
  },
  {
    id: 15,
    status: true,
    img: "/images/animal/15.png",
    link: "",
    name: "คลินิกสัตว์น้ำ",
    vet: [
      {
        personID: 1,
        img: "/images/pic_img_vet_clinic/clinic_15/1.png",
        prefix: "น.สพ.",
        frist_name: "วัชร",
        last_name: "ผัดวัน",
        skill: "",
        floot: "ชั้น 1",
        room: "",
        Checkin: {
          date: [
            { timeId: 1, time: "08:30 - 16.30", day: "จันทร์", status: true },
            { timeId: 2, time: "08:30 - 16.30", day: "อังคาร", status: true },
            { timeId: 3, time: "08:30 - 16.30", day: "พุธ", status: true },
            { timeId: 4, time: "08:30 - 16.30", day: "พฤหัสบดี", status: true },
            { timeId: 5, time: "08:30 - 16.30", day: "ศุกร์", status: true },
          ],
        },
      },
    ],
  },
];
const menuSurgery = [
  {
    id: 1,
    status: true,
    img: "/images/animal/01-01.png",
    link: "",
    name: "ศัลยกรรมเนื้อเยื่ออ่อน",
    vet: [
      {
        personID: 1,
        img: "/images/pic_img_vet_surgery/surgery_1/1.png",
        prefix: "รศ.สพ.ญ.ดร.",
        frist_name: "วรรณนา",
        last_name: "สุริยาสถาพร",
        skill: "",
      },
      {
        personID: 2,
        img: "/images/pic_img_vet_surgery/surgery_1/2.png",
        prefix: "รศ.น.สพ.ดร.",
        frist_name: "วรพัฒน์",
        last_name: "ประชาศิลป์ชัย",
        skill: "",
      },
      {
        personID: 3,
        img: "/images/pic_img_vet_surgery/surgery_1/3.png",
        prefix: "น.สพ.",
        frist_name: "กฤฒิเดช",
        last_name: "ธนงค์พิชเญศ",
        skill: "",
      },
      {
        personID: 4,
        img: "/images/pic_img_vet_surgery/surgery_1/4.png",
        prefix: "สพ.ญ.",
        frist_name: "ชลธิชา",
        last_name: "ปราชัย",
        skill: "",
      },
    ],
  },
  {
    id: 2,
    status: true,
    img: "/images/animal/01-02.png",
    link: "",
    name: "ศัลยกรรมกระดูก",
    vet: [
      {
        personID: 1,
        img: "/images/pic_img_vet_surgery/surgery_2/1.png",
        prefix: "รศ.สพ.ญ.ดร.",
        frist_name: "อารีรัตน์",
        last_name: "อากาศวิภาต",
        skill: "",
      },
      {
        personID: 2,
        img: "/images/pic_img_vet_surgery/surgery_2/2.jpg",
        prefix: "สพ.ญ.",
        frist_name: "ลัดดาวรรณ",
        last_name: "สมรูป",
        skill: "",
      },
      {
        personID: 3,
        img: "/images/pic_img_vet_surgery/surgery_2/3.png",
        prefix: "น.สพ.",
        frist_name: "ภวินท์ชล",
        last_name: "อาภรณ์แก้ว",
        skill: "",
      },
    ],
  },
  {
    id: 3,
    status: true,
    img: "/images/animal/01-03.png",
    link: "",
    name: "วิสัญญี",
    vet: [
      {
        personID: 1,
        img: "/images/pic_img_vet_surgery/surgery_3/1.png",
        prefix: "ผศ.สพ.ญ.ดร.",
        frist_name: "กณวีร์",
        last_name: "วาฤทธิ์",
        skill: "",
      },
      {
        personID: 2,
        img: "/images/pic_img_vet_surgery/surgery_3/2.png",
        prefix: "สพ.ญ.",
        frist_name: "ศลิษา",
        last_name: "เลิศศรีมงคล",
        skill: "",
      },
      {
        personID: 3,
        img: "/images/pic_img_vet_surgery/surgery_3/3.png",
        prefix: "สพ.ญ.",
        frist_name: "ขัตติยา",
        last_name: "กุมเพ็ชร",
        skill: "",
      },
    ],
  },
  {
    id: 4,
    status: true,
    img: "/images/animal/01-04.png",
    link: "",
    name: "ทันตกรรมและช่องปาก",
    vet: [
      {
        personID: 1,
        img: "/images/pic_img_vet_surgery/surgery_4/1.png",
        prefix: "ผศ.น.สพ.ดร.",
        frist_name: "เกรียงไกร",
        last_name: "ทองก้อน",
        skill: "",
      },

    ],
  },
  {
    id: 5,
    status: true,
    img: "/images/animal/01-05.png",
    link: "",
    name: "ส่องกล้องตรวจ",
    vet: [
      {
        personID: 1,
        img: "/images/pic_img_vet_surgery/surgery_5/1.png",
        prefix: "รศ.สพ.ญ.ดร.",
        frist_name: "วรรณนา",
        last_name: "สุริยาสถาพร",
        skill: "",
      },

    ],
  },
];

const menuDiagnose = [
  {
    id: 1,
    status: true,
    img: "/images/animal/02-01.png",
    link: "",
    name: "ศูนย์อัลตร้าซาวน์",
    personal: [
      {
        id: 1,
      },
    ],
  },
  {
    id: 2,
    status: true,
    img: "/images/animal/02-02.png",
    link: "",
    name: "X-Ray",
  },
  {
    id: 3,
    status: true,
    img: "/images/animal/02-03.png",
    link: "",
    name: "CT Scan",
  },
];

const menuOther = [
  {
    id: 1,
    status: true,
    img: "",
    link: "",
    name: "ห้องปฏิบัติการโลหิตวิทยา",
  },
  {
    id: 2,
    status: true,
    img: "",
    link: "",
    name: "หออภิบาลสัตว์ป่วย",
  },
  {
    id: 3,
    status: true,
    img: "",
    link: "",
    name: "หน่วยฉุกเฉิน",
  },
  {
    id: 4,
    status: true,
    img: "",
    link: "",
    name: "อายุรกรรมทั่วไป",
  },
];

// Menu New
const menuNew = [
  { id: 1, status: true, link: "", name: "ข่าวประชาสัมพันธ์" },
  { id: 2, status: true, link: "", name: "ความรู้เกี่ยวกับสัตวเลี้ยง" },
];

const menuContact = [
  { id: 1, status: true, link: "/contact", name: "ติดต่อเรา" },
  {
    id: 2,
    status: true,
    link: "https://vmcmu.vet.cmu.ac.th/pages/PDPA/PDPA#gallery",
    name: "นโยบายความเป็นส่วนตัว",
  },
  {
    id: 3,
    status: true,
    link: "https://vmcmu.vet.cmu.ac.th",
    name: "เว็บไซต์คณะสัตวแพทยศาสตร์ มช.",
  },
];

const bannerSide = [
  {
    id: 1,
    status: true,
    link: "",
    img: "/images/banner/412560910_6868375936592125_2554178217129048543_n 1.png",
    name: "ข่าวประชาสัมพันธ์",
  },
];

const bannerHealth = [
  {
    id: 1,
    status: true,
    img: "/images/info/X-stand1.png",
  },
  {
    id: 2,
    status: true,
    img: "/images/info/X-stand2.png",
  },
  {
    id: 3,
    status: true,
    img: "/images/info/X-stand3.png",
  },
  {
    id: 4,
    status: true,
    img: "/images/info/banner1.jpg",
  },
];

const dataFloor = [
  {
    id: 1,
    floor: 1,
    rooms: [
      {
        roomid: 1,
        roomname_th: "ห้องฉุกเฉิน",
        roomname_en: "EMERGENCY",
      },
      {
        roomid: 2,
        roomname_th: "โถงพักคอย",
        roomname_en: "LOBBY",
      },
      {
        roomid: 3,
        roomname_th: "ห้องอัลตร้าซาวด์",
        roomname_en: "ULTRASOUND ROOM",
      },
      {
        roomid: 4,
        roomname_th: "ศูนย์กายภาพบำบัด",
        roomname_en: "REHABILITATION",
      },
      {
        roomid: 5,
        roomname_th: "คลินิกอายุรกรรม",
        roomname_en: "MEDICAL",
      },
      {
        roomid: 6,
        roomname_th: "ห้องส่องกล้องตรวจ",
        roomname_en: "ENDOSCOPY ROOM",
      },
      {
        roomid: 7,
        roomname_th: "ลงทะเบียน",
        roomname_en: "REGISTORATION",
      },
      {
        roomid: 8,
        roomname_th: "ห้องให้สารน้ำ",
        roomname_en: "INFUSION ROOM",
      },
      {
        roomid: 9,
        roomname_th: "คลินิกสัตว์น้ำ",
        roomname_en: "AQUATIC ANIMAL CLINIC",
      },
      {
        roomid: 10,
        roomname_th: "การเงิน",
        roomname_en: "CASHIER",
      },
      {
        roomid: 11,
        roomname_th: "ลงทะเบียนศัลยกรรม",
        roomname_en: "SURGERY REGISTORATION",
      },
      {
        roomid: 12,
        roomname_th: "ห้องเอ็กซ์เรย์ คอมพิวเตอร์",
        roomname_en: "CT ROOM",
      },
      {
        roomid: 13,
        roomname_th: "ห้องยา",
        roomname_en: "PHARMACY",
      },
      {
        roomid: 14,
        roomname_th: "ห้องถ่ายภาพรังสี",
        roomname_en: "X-RAY ROOM",
      },
      {
        roomid: 15,
        roomname_th: "คลินิกทันตกรรม",
        roomname_en: "DENTAL CLINIC",
      },
    ],
  },

  {
    id: 2,
    floor: 2,
    rooms: [
      {
        roomid: 1,
        roomname_th: "โถงพักคอย",
        roomname_en: "LOBBY",
      },
      {
        roomid: 2,
        roomname_th: "ห้องพักสัตวแพทย์",
        roomname_en: "COMMON ROOM (VET)",
      },
      {
        roomid: 3,
        roomname_th: "ห้องประชุมผู้บริหาร",
        roomname_en: "MEETING ROOM",
      },
      {
        roomid: 4,
        roomname_th: "คลินิกเฉพาะทาง",
        roomname_en: "SPECIALTY CLINIC",
      },

      {
        roomid: 5,
        roomname_th: "ห้องพักเจ้าหน้าที่",
        roomname_en: "COMMON ROOM (STAFF)",
      },
      {
        roomid: 6,
        roomname_th: "ห้องเรียน",
        roomname_en: "LEARNING SPACE",
      },
      {
        roomid: 7,
        roomname_th: "คลินิกสัตว์เลี้ยงพิเศษ",
        roomname_en: "EXOTIC PET CLINIC",
      },
      {
        roomid: 8,
        roomname_th: "ห้องพักนักศึกษา",
        roomname_en: "COMMON ROOM (STUDENT)",
      },
      {
        roomid: 9,
        roomname_th: "ทางเชื่อมอาคาร",
        roomname_en: "SKYWALK",
      },

      {
        roomid: 10,
        roomname_th: "ห้องอาจารย์พิเศษ",
        roomname_en: "VISITING PROFESSOR ROOM",
      },
      {
        roomid: 11,
        roomname_th: "สำนักงาน",
        roomname_en: "OFFICE",
      },

      {
        roomid: 12,
        roomname_th: "ศูนย์ฝึกปฏิบัติทักษะ ทางคลินิก",
        roomname_en: "CLINICAL SKILL CENTER",
      },
    ],
  },

  {
    id: 3,
    floor: 3,
    rooms: [
      {
        roomid: 1,
        roomname_th: "ห้องปฏิบัติการ",
        roomname_en: "LABORATORY",
      },
      {
        roomid: 2,
        roomname_th: "ธนาคารเลือด",
        roomname_en: "BLOOD BANK",
      },
      {
        roomid: 3,
        roomname_th: "หน่วยจ่ายกลาง",
        roomname_en: "CENTRAL SUPPLY UNIT",
      },
      {
        roomid: 4,
        roomname_th: "ห้องเก็บสารเคมี",
        roomname_en: "CHEMICAL STORAGE ROOM",
      },
      {
        roomid: 5,
        roomname_th: "ห้องปฏิบัติการเพื่องานวิจัย",
        roomname_en: "RESEARCH LABORATORY",
      },
      {
        roomid: 6,
        roomname_th: "ห้องแก๊ส",
        roomname_en: "GAS STORAGE ROOM",
      },
      {
        roomid: 7,
        roomname_th: "ห้องเตรียมสารเคมี",
        roomname_en: "CHEMICAL PREPARATION ROOM",
      },
      {
        roomid: 8,
        roomname_th: "ห้องพักนักศึกษา",
        roomname_en: "CONFERENCE ROOM",
      },
      {
        roomid: 9,
        roomname_th: "ห้องรับตัวอย่าง",
        roomname_en: "SAMPLE RECEPTION",
      },
      {
        roomid: 10,
        roomname_th: "ห้องพักเจ้าหน้าที่",
        roomname_en: "COMMON ROOM (STAFF)",
      },
    ],
  },

  {
    id: 4,
    floor: 4,
    rooms: [
      {
        roomid: 1,
        roomname_th: "หออภิบาลสัตว์ป่วย",
        roomname_en: "WARD",
      },
      {
        roomid: 2,
        roomname_th: "ห้องพักฟื้น",
        roomname_en: "RECOVERY ROOM",
      },
      {
        roomid: 3,
        roomname_th: "ห้องเยี่ยมสัตว์ป่วยใน",
        roomname_en: "VISITING ROOM",
      },
      {
        roomid: 4,
        roomname_th: "ห้องกักโรค",
        roomname_en: "QUARANTINE ROOM",
      },
      {
        roomid: 5,
        roomname_th: "ห้องรับรองพิเศษ",
        roomname_en: "VIP ROOM",
      },
      {
        roomid: 6,
        roomname_th: "ห้องเก็บยาเวชภัณฑ์",
        roomname_en: "MEDICAL SUPPLY STORAGE",
      },
      {
        roomid: 7,
        roomname_th: "หออภิบาลสัตว์ป่วยวิกฤต",
        roomname_en: "CCU",
      },
      {
        roomid: 8,
        roomname_th: "สวนลอยฟ้า",
        roomname_en: "ROOF GARAGE",
      },
    ],
  },
];

const newsContent = [
  {
    id: 991,
    status: true,
    img: "/images/news/day27.jpg",
    tag: "ข่าวประชาสัมพันธ์",
    date: "1 พฤศจิกายน 2568",
    detail: `
    <div class="flex flex-col gap-5 ">
      <div class="text-xl text-[#0F4D81]">
     ศูนย์การเรียนรู้และส่งเสริมสุขภาพทางสัตวแพทย์ (NOVEL CMU)
      </div>
  
      <div>
        
        <div>
         ✨ศูนย์การศึกษาหลังปริญญา คณะสัตวแพทยศาสตร์ มหาวิทยาลัยเชียงใหม่ ได้จัดโครงการอบรมเชิงปฏิบัติการ "𝗥𝗲𝗵𝗮𝗯𝗶𝗹𝗶𝘁𝗮𝘁𝗶𝗼𝗻 𝗶𝗻 𝗦𝗺𝗮𝗹𝗹 𝗔𝗻𝗶𝗺𝗮𝗹𝘀" สำหรับสัตวแพทย์ ระหว่างวันที่ 27 – 28 ตุลาคม 2568 ณ คณะสัตวแพทยศาสตร์ มหาวิทยาลัยเชียงใหม่ โดยได้รับเกียรติจาก ศ.(เชี่ยวชาญพิเศษ) ดร.น.สพ.กรกฎ งานวงศ์พาณิชย์ คณบดีคณะสัตวแพทยศาสตร์ มหาวิทยาลัยเชียงใหม่ เป็นประธานกล่าวเปิดโครงการอย่างเป็นทางการ เพื่อพัฒนาองค์ความรู้และเสริมทักษะการประยุกต์ใช้แนวทางการบำบัดทางกายภาพที่เหมาะสมในสัตว์เล็ก
        </div>
        <div>
          การอบรมได้แบ่งเนื้อหาออกเป็นสองส่วนสำคัญ โดยวันที่ 27 ตุลาคม 2568 เป็นภาคบรรยายให้ความรู้ ณ ห้องประชุม E115 ครอบคลุมการตรวจวินิจฉัยทางออร์โธปิดิกส์และระบบประสาท (Orthopedic and Neurologic examination) รวมถึงการใช้เทคโนโลยีบำบัด อาทิ Laser Therapy, Peripheral Magnetic Stimulation, Electrical Stimulation และ Shockwave โดยได้รับเกียรติจากวิทยากรผู้เชี่ยวชาญ 4 ท่าน 🎓 ได้แก่ ผศ.ดร.สพ.ญ.นิยดา ทิตาราม จากสำนักวิชาสัตวแพทยศาสตร์ คณะสัตวแพทยศาสตร์ มหาวิทยาลัยเชียงใหม่, สพ.ญ.ศลิษา เลิศศรีมงคล จากศูนย์การเรียนรู้และส่งเสริมสุขภาพทางสัตวแพทย์ภาคเหนือ (NOVEL CMU), พร้อมด้วย สพ.ญ.นภาภรณ์ เสนารัตน์ และ สพ.ญ.ปิยธิดา อาจอ่ำ จากโรงพยาบาลสัตว์คณะสัตวแพทยศาสตร์ มหาวิทยาลัยเกษตรศาสตร์ วิทยาเขตบางเขน สำหรับวันที่ 28 ตุลาคม 2568 เป็นภาคปฏิบัติการ (Workshop) ณ ห้องปฏิบัติการ C107 ซึ่งสัตวแพทย์ผู้เข้าร่วมได้ฝึกฝนทักษะเชิงปฏิบัติ (Hands-on) และฝึกใช้อุปกรณ์ฟื้นฟูสมรรถภาพสัตว์เลี้ยงอย่างเข้มข้น เพื่อเสริมสร้างทักษะเพื่อปรับใช้ในการปฏิบัติงานคลินิกจริง🐕
        </div>
        <div>
          ศูนย์การศึกษาหลังปริญญาฯ ขอแสดงความขอบคุณอย่างสูง ต่อคณะวิทยากรทุกท่าน และผู้สนับสนุนหลัก บริษัท อินโนเวชั่น ฟอร์ เบทเทอร์ ไลฟ์ จำกัด รวมถึงสัตวแพทย์ทุกท่านที่ให้ความไว้วางใจเข้าร่วมอบรม ทางศูนย์ฯ หวังเป็นอย่างยิ่งว่าองค์ความรู้และทักษะที่ได้รับจะสามารถนำไปต่อยอดการปฏิบัติงานได้อย่างมีประสิทธิภาพ และจะได้รับการตอบรับที่ดีจากทุกท่านในกิจกรรมครั้งต่อไป🌱
        </div>
    
      </div> 
        <div>
          📸ภาพบรรยากาศกิจกรรมเพิ่มเติม: <a href="https://cmu.to/BGyLC" target="_blank">https://cmu.to/BGyLC</a> 
        </div>
       <div class="flex justify-center">
          <div class="w-full max-w-[600px]">
            <iframe src="https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2Fpermalink.php%3Fstory_fbid%3Dpfbid02ZZTsd6ci33csTtbDmjj7ZHqqDdSzFPVHacscaFx8yY6zNXYDxMg4CKcDV1nk7ASzl%26id%3D61558866538285&show_text=true&width=500" width="500" height="800" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>
          </div>
      </div>
      <div>
        🔗 แผนที่: <a class="text-gray-500" href="https://maps.app.goo.gl/jnbdJNiNqmdgwfrt7" target="_blank">https://maps.app.goo.gl/jnbdJNiNqmdgwfrt7</a>
      </div>
    </div> 
`,
    link: "https://www.facebook.com/NOVEL.VMCMU",
  },

  {
    id: 992,
    status: true,
    img: "/images/news/day26.jpg",
    tag: "ข่าวประชาสัมพันธ์",
    date: "31 ตุลาคม 2568",
    detail: `
    <div class="flex flex-col gap-5 ">
      <div class="text-xl text-[#0F4D81]">
     ศูนย์การเรียนรู้และส่งเสริมสุขภาพทางสัตวแพทย์ (NOVEL CMU)
      </div>
  
      <div>
        
        <div>
         เมื่อวันอาทิตย์ที่ 26 ตุลาคม 2568 ที่ผ่านมา ศูนย์การศึกษาหลังปริญญา คณะสัตวแพทยศาสตร์ มหาวิทยาลัยเชียงใหม่ ได้จัดกิจกรรมสุดพิเศษ "𝑹𝒆𝒉𝒂𝒃𝒊𝒍𝒊𝒕𝒂𝒕𝒊𝒐𝒏 𝒊𝒏 𝑺𝒎𝒂𝒍𝒍 𝑨𝒏𝒊𝒎𝒂𝒍𝒔 ภาคประชาชน" ณ ลานอเนกประสงค์ (ลาน B) คณะสัตวแพทย์ มช. โดยได้รับเกียรติจาก ผศ.ดร.น.สพ.อติกันต์ ทองทาบ รองคณบดีฝ่ายศูนย์ความเป็นเลิศทางคลินิกและการศึกษาหลังปริญญา เป็นประธานกล่าวเปิดงานอย่างเป็นทางการ กิจกรรมนี้มีวัตถุประสงค์หลัก เพื่อเปิดโอกาสให้เจ้าของสัตว์เลี้ยง ได้เรียนรู้หลักการทำกายภาพบำบัดอย่างถูกต้อง และสามารถนำไปปรับใช้กับเพื่อนรักสี่ขาที่บ้านได้อย่างปลอดภัย ช่วยให้สัตว์เลี้ยงฟื้นตัวได้ไวและมีสุขภาพดีในระยะยาว
        </div>
        <div>
          ภายในงานเต็มไปด้วยความรู้ทั้งภาคบรรยายและภาคปฏิบัติ ที่ต่อยอดจากหลักการทางสัตวแพทย์สู่การดูแลในชีวิตประจำวัน โดยได้รับเกียรติจาก 👩‍⚕️ สพ.ญ.อาริยา สุขะธรรมโม ที่มาบรรยายอย่างเจาะลึกในหัวข้อ "ฝึกสุนัขให้ออกกำลังกายอย่างไร จะได้แข็งแรง" เพื่อเตรียมความพร้อมและทำความเข้าใจพื้นฐานด้านสรีระ ก่อนที่เจ้าของและสัตว์เลี้ยงจะเข้าสู่การฝึกฝนจริงใน 4 ฐานกิจกรรม (𝑊𝑜𝑟𝑘𝑠ℎ𝑜𝑝) สุดสร้างสรรค์และสามารถนำไปใช้ได้จริง ได้แก่ ฐานวิ่งให้ถูกท่า 🏃‍♀️ ฐานเดินให้มีความสุขผูกพันระหว่างสัตว์เลี้ยงและเจ้าของ 🐕 ฐานกระโดดอย่างปลอดภัย 🤸 และฐานดูเพื่อสังเกตทำความเข้าใจการเคลื่อนไหวของสุนัขอย่างลึกซึ้ง 🧐 ซึ่งทั้งหมดนี้จะช่วยให้เจ้าของสามารถนำความรู้ไปประยุกต์ใช้เพื่อฟื้นฟูและเสริมสร้างความแข็งแรงให้กับสัตว์เลี้ยงได้อย่างถูกต้องและมั่นใจ
        </div>
        <div>
          กิจกรรมนี้สำเร็จลุล่วงไปได้ด้วยดีด้วยการสนับสนุนอย่างดียิ่งจาก บริษัท อินโนเวชั่น ฟอร์ เบทเทอร์ ไลฟ์ จำกัด และ บริษัท เพอร์เฟค คอมพาเนียน กรุ๊ป จำกัด 
        </div>
        <div>
         ศูนย์การศึกษาหลังปริญญาฯ ขอแสดงความขอบคุณอย่างสูง ต่อเจ้าของสัตว์เลี้ยงทุกท่าน ❤️ ที่ให้ความไว้วางใจและเข้าร่วมกิจกรรมด้วยความตั้งใจจริง การตอบรับอันดีเยี่ยมในครั้งนี้ถือเป็นกำลังใจและเป็นเครื่องยืนยันว่าการบริการวิชาการด้านสุขภาพสัตว์เลี้ยงเป็นสิ่งสำคัญ ศูนย์ฯ หวังเป็นอย่างยิ่งว่าจะได้รับการสนับสนุนและมีโอกาสต้อนรับทุกท่านอีกครั้งในกิจกรรมครั้งต่อไป เพื่อร่วมกันขับเคลื่อนองค์ความรู้และส่งเสริมสวัสดิภาพสัตว์เลี้ยงอย่างยั่งยืน 🌱  
        </div>

      </div> 
        <div>
          📸ภาพบรรยากาศกิจกรรมเพิ่มเติม: <a href="https://cmu.to/rqP7Y" target="_blank">https://cmu.to/rqP7Y</a> 
        </div>
       <div class="flex justify-center">
          <div class="w-full max-w-[600px]">
            <iframe src="https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2Fpermalink.php%3Fstory_fbid%3Dpfbid02C9JqbxG6kxmyi9USVKrWjCkPNRVpLfZ8fmUjnLrjJ9pcQSWA7SRkfCb8inC6Yc4el%26id%3D61558866538285&show_text=true&width=500" width="500" height="861" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>
          </div>
      </div>
      <div>
        🔗 แผนที่: <a class="text-gray-500" href="https://maps.app.goo.gl/jnbdJNiNqmdgwfrt7" target="_blank">https://maps.app.goo.gl/jnbdJNiNqmdgwfrt7</a>
      </div>
    </div> 
`,
    link: "https://www.facebook.com/NOVEL.VMCMU",
  },

  {
    id: 993,
    status: true,
    img: "/images/news/cuvc2025.jpg",
    tag: "ข่าวประชาสัมพันธ์",
    date: "31 พฤษภาคม 2568",
    detail: `
    <div class="flex flex-col gap-5 ">
      <div class="text-xl text-[#0F4D81]">
     ศูนย์การเรียนรู้และส่งเสริมสุขภาพทางสัตวแพทย์ (NOVEL CMU)

      </div>
      <div>
          💐🎉ขอร่วมแสดงความยินดีกับ🎉💐
      </div>
      <div>
        <div>
            🔸น.สพ. กฤฒิเดช ธนงค์พิชเญศ🔸
        สัตวแพทย์ประจำศูนย์การเรียนรู้และส่งเสริมสุขภาพทางสัตวแพทย์ (NOVEL CMU)
        </div>

        <div>
          ✨ในโอกาสได้รับรางวัล Honorable Mention Research Poster Presentation Award🥇✨
          จากผลงานวิจัยเรื่อง Impact of Dog’s Impulsivity on Cognitive Behavioral Test Performance in Aging Dog 🐶🧠
          ในงานประชุมวิชาการระดับนานาชาติ Chulalongkorn University Veterinary Conference 2025 (CUVC 2025)
          ภายใต้แนวคิด “Together for Sustainability: Advancing One Health and Biosecurity”
          จัดโดยคณะสัตวแพทยศาสตร์ จุฬาลงกรณ์มหาวิทยาลัย
          ณ โรงแรมเซ็นทารา แกรนด์ แอท เซ็นทรัลเวิลด์
          ระหว่างวันที่ 29–30 พฤษภาคม 2568
        </div>

      </div> 
        <div>
          ความสำเร็จครั้งนี้ถือเป็นอีกหนึ่งก้าวสำคัญในการพัฒนางานวิจัยด้านพฤติกรรมสัตว์เลี้ยงสูงวัย ซึ่งมีบทบาทต่อการส่งเสริมสุขภาพสัตว์และแนวคิด One Health อย่างยั่งยืน
        </div>
       <div class="flex justify-center">
          <div class="w-full max-w-[600px]">
            <iframe src="https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2FNOVEL.VMCMU%2Fposts%2F122208102206153144&show_text=true&width=500" width="500" height="582" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>
          </div>
      </div>
      <div>
        🔗 แผนที่: <a class="text-gray-500" href="https://maps.app.goo.gl/jnbdJNiNqmdgwfrt7" target="_blank">https://maps.app.goo.gl/jnbdJNiNqmdgwfrt7</a>
      </div>
    </div> 
`,
    link: "https://www.facebook.com/NOVEL.VMCMU",
  },
  {
    id: 994,
    status: true,
    img: "/images/news/Intrunship7.jpg",
    tag: "ข่าวประชาสัมพันธ์",
    date: "31 พฤษภาคม 2568",
    detail: `
    <div class="flex flex-col gap-y-5">
      <div class="text-xl text-[#0F4D81]">
     🎉 ขอแสดงความยินดีกับสัตวแพทย์โครงการเพิ่มพูนทักษะทางคลินิก (ด้านสัตว์เล็ก) Internship Program รุ่นที่ 7
      </div>
      <div>
         ในโอกาสสำเร็จหลักสูตรอย่างเป็นทางการ วันที่ 30 พฤษภาคม 2568 🎓🐾 ขอให้ความรู้และประสบการณ์ที่ได้รับ นำพาทุกท่านก้าวสู่ความสำเร็จในวิชาชีพสัตวแพทย์อย่างมั่นใจและภาคภูมิใจค่ะ 💕🥰
      </div> 
       <div class="flex justify-center">
          <div class="w-full max-w-[600px]">
           <iframe src="https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2Fpermalink.php%3Fstory_fbid%3D122183368940295551%26id%3D61558866538285&show_text=true&width=500" width="500" height="800" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>
          </div>
      </div>
      <div>
        🔗 แผนที่: <a class="text-gray-500" href="https://maps.app.goo.gl/jnbdJNiNqmdgwfrt7" target="_blank">https://maps.app.goo.gl/jnbdJNiNqmdgwfrt7</a>
      </div>
    </div> 
`,
    link: "https://www.facebook.com/NOVEL.VMCMU",
  },
  {
    id: 995,
    status: true,
    img: "/images/news/NOVEL.jpg",
    tag: "ข่าวประชาสัมพันธ์",
    date: "03 พฤษภาคม 2568",
    detail: `
    <div class="flex flex-col gap-y-5">
      <div class="text-xl text-[#0F4D81]">
     📍ศูนย์การเรียนรู้และส่งเสริมสุขภาพทางสัตวแพทย์ภาคเหนือ ณ คณะสัตวแพทยศาสตร์ มหาวิทยาลัยเชียงใหม่
      </div>
      <div>
      🐶🐱[คลิปฉบับย่อ] INSIDE NOVEL CMU ศูนย์กลางแห่งการเรียนรู้ด้านสุขภาพสัตว์เลี้ยงในภาคเหนือ! พื้นที่แห่งนวัตกรรม ความรู้ และการดูแลสุขภาพสัตว์เลี้ยงอย่างครบวงจร ส่งเสริมการเรียนรู้ทั้งด้านวิชาการและบริการ เพื่อคุณภาพชีวิตที่ดีของสัตว์เลี้ยงที่คุณรัก 🩵

      </div> 
       <div class="flex justify-center">
          <div class="w-full max-w-[600px]">
           <iframe src="https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2FNOVEL.VMCMU%2Fposts%2Fpfbid0HdZG8bfyjJXGC3322z1E8ZpSfv4StJPfDvtsJuGfcmkqFWk87XMUtzwWpe55t8qtl&show_text=true&width=500" width="500" height="582" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>
          </div>
      </div>
      <div>
        🔗 แผนที่: <a class="text-gray-500" href="https://maps.app.goo.gl/jnbdJNiNqmdgwfrt7" target="_blank">https://maps.app.goo.gl/jnbdJNiNqmdgwfrt7</a>
      </div>
    </div> 
`,
    link: "https://www.facebook.com/NOVEL.VMCMU",
  },
  {
    id: 996,
    status: true,
    img: "/images/news/CTSCAN.jpg",
    tag: "ข่าวประชาสัมพันธ์",
    date: "02 พฤษภาคม 2568",
    detail: `
    <div class="flex flex-col gap-y-5">
      <div class="text-xl text-[#0F4D81]">
      🔬🩻 ศูนย์เอกซเรย์คอมพิวเตอร์ คณะสัตวแพทยศาสตร์ มช. สำหรับสัตว์เลี้ยง พร้อมให้บริการ
เต็มรูปแบบแล้ววันนี้ ณ ศูนย์การเรียนรู้และส่งเสริมสุขภาพทางสัตวแพทย์ภาคเหนือ NOVEL CMU 💙 
      </div>
      <div>
      🧑🏻‍⚕️🐶 ร่วมรับชมภาพบรรยากาศการวินิจฉัยสัตว์เลี้ยงด้วยการตรวจด้านทัศนวินิจฉัย CT Scan เครื่องมือที่ช่วยให้สัตวแพทย์สามารถวินิจฉัยโรคได้รวดเร็ว แม่นยำ และรักษาสัตว์ได้อย่างมีประสิทธิภาพ 
💜 เปิดบริการ จันทร์ - ศุกร์ 08.30 - 16.30 น. 
📞 ติดต่อสอบถาม: 081-745-1935, 098-458-2500 
      </div> 
       <div class="flex justify-center">
          <div class="w-full max-w-[600px]">
           <iframe src="https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2FNOVEL.VMCMU%2Fposts%2Fpfbid02zE1vYh711seCCQLr3pH6uEb7ZzHqri7SpDKGBxaNADZF7N2p3oeU3FYFqdGxvQkBl&show_text=true&width=500" width="500" height="835" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>
          </div>
      </div>
      <div>
        🔗 แผนที่: <a class="text-gray-500" href="https://maps.app.goo.gl/jnbdJNiNqmdgwfrt7" target="_blank">https://maps.app.goo.gl/jnbdJNiNqmdgwfrt7</a>
      </div>
    </div> 
`,
    link: "https://www.facebook.com/NOVEL.VMCMU",
  },
  {
    id: 997,
    status: true,
    img: "/images/news/discount10.jpg",
    tag: "ข่าวประชาสัมพันธ์",
    date: "09 เมษยน 2568",
    detail: `
    <div class="flex flex-col gap-y-5">
      <div class="text-xl text-[#0F4D81]">
      ✨🐾 งานนี้คนรักน้องหมาน้องแมวต้องกดหัวใจรัว ๆ 💜
      </div>
      <div>📢 พบกับงาน “สุขภาพดี สัตว์เลี้ยงแฮปปี้”
กิจกรรมสุดน่ารักที่จัดมาเพื่อเจ้าตัวจิ๋วของคุณ! 🐶🐱
📅 วันพฤหัสบดีที่ 1 พฤษภาคม 2568 ⏰ เวลา 09.00 – 12.00 น.
📍 ณ ห้องประชุมฮอลล์ 1 ชั้น 3 อาคาร NOVEL CMU
      </div> 
       <div class="flex justify-center">
          <div class="w-full max-w-[600px]">
           <iframe src="https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2Fveterinarycmu%2Fposts%2Fpfbid02c3BGRPtyvvoddx3HkJvJcW8Yj5qrrRujqfvaNkjqc7ixMFgh7PhuLehmWsWoPqR3l&show_text=true&width=500" width="500" height="445" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>
          </div>
      </div>
      <div>
        🔗 แผนที่: <a class="text-gray-500" href="https://maps.app.goo.gl/jnbdJNiNqmdgwfrt7" target="_blank">https://maps.app.goo.gl/jnbdJNiNqmdgwfrt7</a>
      </div>
    </div> 
`,
    link: "https://www.facebook.com/photo/?fbid=1085247753404587&set=a.728609955735037",
  },
  {
    id: 998,
    status: true,
    img: "/images/news/open_novel.jpg",
    tag: "ข่าวประชาสัมพันธ์",
    date: "13 กุมภาพันธ์ 2568",
    detail: `
    <div class="flex flex-col gap-y-5">
      <div class="text-xl text-[#0F4D81]">
      📢 ประกาศแจ้งย้ายสถานที่ให้บริการตรวจรักษาสัตว์🚨
      </div>
      <div>✨ตั้งแต่ 1 พฤษภาคมนี้ เป็นต้นไป 📅
            การให้บริการตรวจรักษาสัตว์จะย้ายจากโรงพยาบาลสัตว์เล็ก ไปยัง
      🏥 โรงพยาบาลสัตว์แห่งใหม่ ณ "อาคารสัตวเวชบำรุง 𝐍𝐎𝐕𝐄𝐋 𝐂𝐌𝐔"
      📍 คณะสัตวแพทยศาสตร์ มหาวิทยาลัยเชียงใหม่ (ไร่แม่เหียะ)
      </div> 
       <div class="flex justify-center">
          <div class="w-full max-w-[600px]">
            <iframe 
              src="https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2Fveterinarycmu%2Fposts%2F1085247996737896&show_text=true&width=600" 
              width="100%" 
              height="725" 
              style="border:none; overflow:hidden; aspect-ratio: 4 / 5;" 
              scrolling="no" 
              frameborder="0" 
              allowfullscreen="true" 
              allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share">
            </iframe>
          </div>
      </div>
      <div>
        🔗 แผนที่: <a class="text-gray-500" href="https://maps.app.goo.gl/jnbdJNiNqmdgwfrt7" target="_blank">https://maps.app.goo.gl/jnbdJNiNqmdgwfrt7</a>
      </div>
    </div> 
`,
    link: "https://www.facebook.com/photo/?fbid=1085247753404587&set=a.728609955735037",
  },

  {
    id: 999,
    status: true,
    img: "/images/news/CT_Scan.jpg",
    tag: "ข่าวประชาสัมพันธ์",
    date: "9 กันยายน 2567",
    detail: `
    <div class="flex flex-col gap-y-5">
      <div class="text-xl text-[#0F4D81]">
      📢 ค่าบริการเอกซเรย์คอมพิวเตอร์ของเราเริ่มต้นที่ 5,000 บาท/ ครั้ง🚨
      </div>
      <div>✨ราคานี้จะเป็นการให้บริการแบบ CT scan 1 Part (1 ส่วน) ไม่รวมค่าหัตถการ ค่าอุปกรณ์ต่าง ๆ และการฉีดสารทึบรังสี โดยจะมีการเปลี่ยนแปลงไปตามน้ำหนัก และดุลยพินิจของสัตวแพทย์เจ้าของไข้
              ทางศูนย์เอกซเรย์คอมพิวเตอร์สำหรับสัตว์เลี้ยงของเราได้ติดตั้งเครื่องเอกซเรย์คอมพิวเตอร์ที่มีประสิทธิภาพสูงที่สามารถสร้างภาพได้สูงถึง 390 ภาพต่อการสแกน 1 รอบ ซึ่งทำให้ได้ความละเอียดของภาพดีที่สุดและยังลดปริมาณรังสีที่ได้รับอีกด้วย
              ปัจจุบันมีสัตว์เลี้ยงแสนน่ารักเข้ามาใช้บริการของเรา และได้เข้ารับการรักษากับทางสัตวแพทย์อย่างตรงจุด  ทางศูนย์เอกซเรย์คอมพิวเตอร์สัตว์เลี้ยงจึงขอขอบพระคุณทุกท่านที่ไว้วางใจในการบริการของเรา และเรายินดีให้บริการเอกซ์เรย์คอมพิวเตอร์ให้กับสัตว์เลี้ยงทุกชนิด ✨
      </div> 
      <div class="flex justify-center">
          <div class="w-full max-w-[600px]">
            <iframe 
              src="https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2Fpermalink.php%3Fstory_fbid%3D122186056910219011%26id%3D61556570334515&show_text=true&width=600" 
              width="100%" 
              height="725" 
              style="border:none; overflow:hidden; aspect-ratio: 4 / 5;" 
              scrolling="no" 
              frameborder="0" 
              allowfullscreen="true" 
              allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share">
            </iframe>
          </div>
      </div>
      <div>
        🔗 แผนที่: <a class="text-gray-500" href="https://maps.app.goo.gl/jnbdJNiNqmdgwfrt7" target="_blank">https://maps.app.goo.gl/jnbdJNiNqmdgwfrt7</a>
      </div>
      
    </div> 
`,
    link: "https://www.facebook.com/permalink.php?story_fbid=122186056910219011&id=61556570334515&ref=embed_post",
  },
  {
    id: 1000,
    status: true,
    img: "/images/news/QrcodeLineOA.jpg",
    tag: "ข่าวประชาสัมพันธ์",
    date: "9 กันยายน 2567",
    detail: `
    <div class="flex flex-col gap-y-5">
      <div class="text-xl text-[#0F4D81]">
      📢ศูนย์ 𝑵𝑶𝑽𝑬𝑳 𝑪𝑴𝑼 มีช่องทางการติดต่อ 𝗟𝗜𝗡𝗘 𝗢𝗳𝗳𝗶𝗰𝗶𝗮𝗹 แล้วนะ🤩
      </div>
      <div>
      เพื่ออำนวยความสะดวกให้กับเจ้าของสัตว์เลี้ยงในการสอบถามข้อมูลเพิ่มเติมเกี่ยวกับการเข้ารับบริการ และรับข่าวสารประชาสัมพันธ์ต่าง ๆ จากทางศูนย์ฯ ได้อย่างรวดเร็ว✨
      </div> 
      <div class="flex justify-center">
          <div class="w-full max-w-[600px]">
            <iframe 
              src="https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2FNOVEL.VMCMU%2Fposts%2Fpfbid0SrKDuWsCGvLiDcJmELJmQzRvLQyfUfVoB2B93aYGdFBcJQoVkfZvXEwxxW4xEYFXl&show_text=true&width=600" 
              width="100%" 
              height="725" 
              style="border:none; overflow:hidden; aspect-ratio: 4 / 5;" 
              scrolling="no" 
              frameborder="0" 
              allowfullscreen="true" 
              allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share">
            </iframe>
          </div>
      </div>
      <div>
        🔗 เพิ่มศูนย์ 𝑵𝑶𝑽𝑬𝑳 𝑪𝑴𝑼 เป็นเพื่อนได้แล้ววันนี้ ทาง 𝐋𝐢𝐧𝐞 @𝟎𝟖𝟏𝐜𝐭𝐝𝐦𝐢
      </div>
    </div> 
`,
    link: "https://www.facebook.com/NOVEL.VMCMU/posts/122137896554153144?ref=embed_post",
  },
];

export {
  menuAbout,
  specialClinic,
  menuNew,
  menuContact,
  menuSurgery,
  menuDiagnose,
  bannerSide,
  bannerHealth,
  newsContent,
  dataFloor,
  menuOther,
};
